// extracted by mini-css-extract-plugin
export default {"btn":"ToggleTheme_btn__BcBIh","icon":"ToggleTheme_icon__+jJxD"};